var map = {
	"./BiminiBlue.png": 423,
	"./BuffolaBrown.png": 4796,
	"./CapriBlue.png": 3786,
	"./CarinaWhite.png": 3246,
	"./CloudWhite.png": 5767,
	"./ForrestGreen.png": 3217,
	"./IntOrange.png": 2916,
	"./LightGray.png": 8512,
	"./MoonDust.png": 6,
	"./PatrolBlue.png": 7067,
	"./StingrayGray.png": 4681,
	"./StormBlue.png": 9770,
	"./SunfastRed.png": 308,
	"./WarmGray.png": 5475,
	"./WineRed.png": 8737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2072;